import { IsNumber } from 'class-validator';

export class PropertyAdminDashboardMetricsDto {
  @IsNumber()
  totalProperties!: number;

  @IsNumber()
  pendingDocumentsCount!: number;

  @IsNumber()
  moderationAlertsCount!: number;
}
